import * as React from "react";

function SvgCheckCircleIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194 194" {...props}><path d="M96.9 2c-52.4 0-95 42.6-95 95s42.6 95 95 95 95-42.6 95-95-42.6-95-95-95zM76.6 144.7l-36.5-36.5 10.6-10.6 25.9 25.9 68.8-68.8L156 65.3l-79.4 79.4z" /></svg>;
}

export default SvgCheckCircleIcon;